import React from 'react';
import PropTypes from 'prop-types';
import HouseholdSectionPicker
  from 'Components/Flyouts/HouseholdInfo/Sections/Section/HouseholdSectionPicker/HouseholdSectionPicker';
import HouseholdSectionSecurityPicker from 'Components/Flyouts/HouseholdInfo/Sections/Security/Picker';
import {
  pick,
} from 'Helpers/Affordances';
import fr
  from '../../../../../../../packages/facet-rest';

const SecuritySection = ({ householdResource }) => {
  return pick(householdResource, {
    [fr.relationships.householdSectionSecurity.name]: (
      <HouseholdSectionPicker label="Security Reset" resource={householdResource}>
        <HouseholdSectionSecurityPicker resource={householdResource} />
      </HouseholdSectionPicker>
    ),
  }, null);
};

SecuritySection.propTypes = {
  householdResource: PropTypes.object.isRequired,
};

export default SecuritySection;
